import { render } from "./ElementGroupManager.vue?vue&type=template&id=c555c092&scoped=true"
import script from "./ElementGroupManager.vue?vue&type=script&lang=js"
export * from "./ElementGroupManager.vue?vue&type=script&lang=js"

import "./ElementGroupManager.vue?vue&type=style&index=0&id=c555c092&lang=scss&scoped=true"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c555c092"]])

export default __exports__